module.exports = __webpack_public_path__ + "static/linguamillDesktopBig-b9cd316785653319fb0aaba7549e655c.jpg";